import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import nestCollection from 'scoreboard/components/nest-collection'
import permissions from 'scoreboard/components/permissions'
import i18n from 'scoreboard/components/i18n'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import fileInfo from 'scoreboard/components/files/file-info'

function download(documentId, revisionId) {
	let url = `files/${documentId}`
	if (revisionId) {
		url += `/revisions/${revisionId}`
	}
	url += '/download'
	downloadFromUrl(url)
}

/**
 *
 * @param url A relative url e.g. `datasets/1/spreadsheets/2
 */
function downloadFromUrl(url) {
	// A form is used because loading large files into memory using Xhr's and Blobs
	// doesn't scale. (#31000)
	const downloadForm = $('.file-download-form') // see main.hbs
	downloadForm.attr('action', scoreboardUrl(url))
	downloadForm.trigger('submit')
}

function getIcon(type, fileName, isMono) {
	if (type === 'folder') {
		return 'folder'
	}

	let icon = fileInfo.icon(fileName)
	if (isMono) {
		return ['document-blank', 'docs-document'].includes(icon) ? icon : icon + '-mono'
	} else {
		return icon
	}
}

var File = Backbone.Model.extend({

	section: 'files',
	domainType: 'file',

	urlRoot: 'api/files',

	isEditable: function() {
		return permissions.documents(this.get('organizationId'))
	},

	initialize: function() {
		this.revisions = new Backbone.Collection(this.get('revisions'))
		nestCollection({
			parent: this,
			parentAttribute: 'revisions',
			children: this.revisions
		})
	},

	download: function() {
		download(this.id)
	},

	downloadRevision: function(revisionId) {
		download(this.id, revisionId)
	},

	/**
	 * Returns an appropriate message if uploading a new revision will affect dashboards;
	 * returns null otherwise
	 */
	replaceRevisionDependencyMessage: function () {
		return this.buildDependencyMessage(this.revisions.last().get('dashboardDependencies'),
			'documents.replaceDashboardImages.uploadRevision')
	},

	/**
	 * Returns an appropriate message if deleting a revision will affect dashboards;
	 * returns null otherwise
	 */
	deleteRevisionDependencyMessage: function (revisionId) {
		return this.buildDependencyMessage(this.revisions.get(revisionId).get('dashboardDependencies'),
			'documents.replaceDashboardImages.deleteRevision')
	},

	/**
	 * Returns an appropriate message if deleting a file will affect dashboards;
	 * returns null otherwise
	 */
	deleteFileDependencyMessage: function () {
		let allDependencies = _(this.revisions.toArray())
			.map(r => r.get('dashboardDependencies'))
			.sum()

		return this.buildDependencyMessage(allDependencies,
			'documents.replaceDashboardImages.deleteFile')
	},

	buildDependencyMessage: function (dashboardDependencies, part2Prefix) {
		if (_.isNil(dashboardDependencies) || dashboardDependencies === 0) {
			return null
		}

		return i18n.countMessage('documents.imageUsedByDashboards', dashboardDependencies)
			+ ' ' + i18n.countMessage(part2Prefix, dashboardDependencies)
	},

	destroyRevision: function(revisionId) {
		return $.ajax(_.result(this, 'urlRoot') + '/revisions/' + revisionId, {
			type: 'delete',
			success: function() {
				let newestRevision = this.revisions.at(-1)
				let deletedRevision = this.revisions.get(revisionId)

				if (newestRevision === deletedRevision) {
					// #24871 If the latest revision is deleted, its dependencies
					// will be swapped to previous (now the latest) revision
					let newNewestRevision = this.revisions.at(-2)
					if (!_.isNil(newestRevision)) {
						newNewestRevision.set('dashboardDependencies', deletedRevision.get('dashboardDependencies'))
					}
				}

				this.revisions.remove(revisionId)
				this.trigger('destroy:revision', revisionId)
			}.bind(this)
		})
	}

})

export default File
export { download }
export { downloadFromUrl }
export { getIcon }

File.__filename__ = 'components/files/file.js'
